import { Field, Int, ObjectType } from '@nestjs/graphql'
import { UserDto } from './model.dto'

@ObjectType()
export class AuthenticatedUserDto {
  @Field(t => UserDto)
  user!: UserDto

  @Field(t => UserDto, { nullable: true })
  mimicUser?: UserDto

  /**
   * Unix seconds at which this session's token expires. The session lives in an httpOnly cookie the
   * client cannot read, so this is the only way it can learn how long it has left. [sc-27671]
   */
  @Field(t => Int, { nullable: true })
  tokenExpires?: number
}
